// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminLayoutController from "./admin_layout_controller"
application.register("admin-layout", AdminLayoutController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavbarDropdownController from "./navbar_dropdown_controller"
application.register("navbar-dropdown", NavbarDropdownController)

import SidebarDropdownController from "./sidebar_dropdown_controller"
application.register("sidebar-dropdown", SidebarDropdownController)

import AdminAvatarDemoController from "./admin_avatar_demo_controller"
application.register("admin-avatar-demo", AdminAvatarDemoController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import AdminCheckboxController from "./admin_checkbox_controller"
application.register("admin-checkbox", AdminCheckboxController)

import AdminToggleController from "./admin_toggle_controller"
application.register("admin-toggle", AdminToggleController)

import AdminRadioController from "./admin_radio_controller"
application.register("admin-radio", AdminRadioController)

import AdminModalController from "./admin_modal_controller"
application.register("admin-modal", AdminModalController)

import AdminConfirmDemoController from "./admin_confirm_demo_controller"
application.register("admin-confirm-demo", AdminConfirmDemoController)

import AdminAccordionController from "./admin_accordion_controller"
application.register("admin-accordion", AdminAccordionController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AdminCalendarController from "./admin_calendar_controller"
application.register("admin-calendar", AdminCalendarController)

import AdminCarouselController from "./admin_carousel_controller"
application.register("admin-carousel", AdminCarouselController)

import AdminDropdownController from "./admin_dropdown_controller"
application.register("admin-dropdown", AdminDropdownController)

import AdminImageResizeController from "./admin_image_resize_controller"
application.register("admin-image-resize", AdminImageResizeController)

import AdminListDropdownController from "./admin_list_dropdown_controller"
application.register("admin-list-dropdown", AdminListDropdownController)

import AdminNotificationController from "./admin_notification_controller"
application.register("admin-notification", AdminNotificationController)

import AdminPopoverController from "./admin_popover_controller"
application.register("admin-popover", AdminPopoverController)

import AdminProgressController from "./admin_progress_controller"
application.register("admin-progress", AdminProgressController)

import AdminSpinnerController from "./admin_spinner_controller"
application.register("admin-spinner", AdminSpinnerController)

import AdminTabsController from "./admin_tabs_controller"
application.register("admin-tabs", AdminTabsController)

import AdminTooltipController from "./admin_tooltip_controller"
application.register("admin-tooltip", AdminTooltipController)

import AdminRangeSliderController from "./admin_range_slider_controller"
application.register("admin-range-slider", AdminRangeSliderController)

import AdminDropzoneController from "./admin_dropzone_controller"
application.register("admin-dropzone", AdminDropzoneController)

import AdminAreaChartController from "./admin_area_chart_controller"
application.register("admin-area-chart", AdminAreaChartController)

import AdminBarChartController from "./admin_bar_chart_controller"
application.register("admin-bar-chart", AdminBarChartController)

import AdminDonutChartController from "./admin_donut_chart_controller"
application.register("admin-donut-chart", AdminDonutChartController)

import AdminLineChartController from "./admin_line_chart_controller"
application.register("admin-line-chart", AdminLineChartController)

import AdminVectorMapController from "./admin_vector_map_controller"
application.register("admin-vector-map", AdminVectorMapController)

import AdminDatePickerController from "./admin_date_picker_controller"
application.register("admin-date-picker", AdminDatePickerController)

import CircularProgressController from "./circular_progress_controller"
application.register("circular-progress", CircularProgressController)

import AdminStocksSliderController from "./admin_stocks_slider_controller"
application.register("admin-stocks-slider", AdminStocksSliderController)

import InboxSidebarController from "./inbox_sidebar_controller"
application.register("inbox-sidebar", InboxSidebarController)

import InboxNavController from "./inbox_nav_controller"
application.register("inbox-nav", InboxNavController)

import CountdownTimerController from "./countdown_timer_controller"
application.register("countdown-timer", CountdownTimerController)

import DataTableController from "./data_table_controller"
application.register("data-table", DataTableController)

import TaskDragController from "./task_drag_controller"
application.register("task-drag", TaskDragController)

import AdminFilterFormController from "./admin_filter_form_controller"
application.register("admin-filter-form", AdminFilterFormController)

import AdminBulkSelectController from "./admin_bulk_select_controller"
application.register("admin-bulk-select", AdminBulkSelectController)

import AdminConfirmSubmitController from "./admin_confirm_submit_controller"
application.register("admin-confirm-submit", AdminConfirmSubmitController)

import AdminFavoriteToggleController from "./admin_favorite_toggle_controller"
application.register("admin-favorite-toggle", AdminFavoriteToggleController)

import AdminScoreHoverController from "./admin_score_hover_controller"
application.register("admin-score-hover", AdminScoreHoverController)

import SurveyViewerController from "./survey_viewer_controller"
application.register("survey-viewer", SurveyViewerController)

import SurveySwipeController from "./survey_swipe_controller"
application.register("survey-swipe", SurveySwipeController)

import SurveyReorderController from "./survey_reorder_controller"
application.register("survey-reorder", SurveyReorderController)

import SurveyHtmlScalerController from "./survey_html_scaler_controller"
application.register("survey-html-scaler", SurveyHtmlScalerController)
